__webpack_require__.p = "/lib/react/";